import { useState } from 'react'
import { Tag } from '#app/components/ui/tag.tsx'

interface Tab {
	id: string
	title: string
	content: string
}

const tabs: Tab[] = [
	{
		id: 'reforestacion',
		title: 'Reforestación',
		content:
			'Como ONG local, articulamos con comunidades, generamos conciencia y movilizamos voluntades, promoviendo una ciudadanía activa en la gestión sostenible del agua. A través de jornadas participativas, plantamos especies nativas, fortaleciendo la biodiversidad y el arraigo comunitario. La reforestación es sembrar futuro.',
	},
	{
		id: 'restauracion',
		title: 'Restauración de ecosistema',
		content:
			'Iniciativas de recuperación y conservación de zonas clave para mantener el equilibrio ambiental.',
	},
	{
		id: 'educacion',
		title: 'Educación y comunidad',
		content:
			'Programas de formación y articulación con actores locales para promover la sostenibilidad.',
	},
]

export default function CommitmentSection() {
	const [activeTab, setActiveTab] = useState<string>('reforestacion')

	return (
		<section className="relative bg-white pt-[48px] pb-[48px] md:pt-[96px] md:pb-[96px]">
			<div className="mx-auto max-w-[1400px] px-[37.5px] md:px-[120px]">
				{/* Tag */}
				<div className="mb-[56px]">
					<Tag
						size="l"
						corner="rounded"
						variant="secondary"
						color="green"
						appearance="solid"
						leftIcon="service"
						option="text-icon-left"
					>
						Acciones
					</Tag>
				</div>

				{/* Content Grid */}
				<div className="flex flex-col gap-8 md:grid md:grid-cols-[614px_1fr]">
					{/* Left Column - Tabs */}
					<div className="order-2 flex flex-col gap-[64px] md:order-1">
						{/* Title */}
						<div className="text-[32px] leading-[45px] font-medium text-blue-900 md:text-[56px] md:leading-[70px]">
							<h2>Nuestro</h2>
							<h2>compromiso</h2>
						</div>

						{/* Tabs */}
						<div className="flex flex-col gap-[32px]">
							{tabs.map((tab) => (
								<button
									key={tab.id}
									onClick={() => setActiveTab(tab.id)}
									className="group flex w-full cursor-pointer flex-col items-start gap-4 text-left transition-all duration-200 hover:opacity-80"
								>
									{/* Tab Title */}
									<h3
										className={`font-parkinsans text-[32px] leading-[45px] font-normal transition-colors duration-300 md:text-[40px] md:leading-[56px] ${
											activeTab === tab.id
												? 'text-blue-900'
												: 'text-neutral-600 group-hover:text-neutral-700'
										}`}
									>
										{tab.title}
									</h3>

									{/* Progress Bar - animated entrance */}
									<div
										className={`h-[2px] w-full overflow-hidden transition-all duration-500 ${
											activeTab === tab.id ? 'opacity-100' : 'opacity-0'
										}`}
									>
										<div
											className={`h-full bg-gradient-to-r from-blue-500 to-green-500 transition-transform duration-500 ${
												activeTab === tab.id
													? 'translate-x-0'
													: '-translate-x-full'
											}`}
										/>
									</div>

									{/* Tab Content - animated slide down */}
									<div
										className={`grid transition-all duration-500 ease-in-out ${
											activeTab === tab.id
												? 'grid-rows-[1fr] opacity-100'
												: 'grid-rows-[0fr] opacity-0'
										}`}
									>
										<div className="overflow-hidden">
											<p className="font-inter text-[16px] leading-[26px] font-normal text-neutral-800">
												{tab.content}
											</p>
										</div>
									</div>
								</button>
							))}
						</div>
					</div>

					{/* Right Column - Image */}
					<div className="order-1 md:order-2">
						<img
							src="/img/proposito/plantita.png"
							alt="Nuestro compromiso"
							className="h-auto w-full rounded-[24px] object-cover"
						/>
					</div>
				</div>
			</div>
		</section>
	)
}
